// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditPopup_deleteButton__Pcp6W","field":"EditPopup_field__W2asb","text":"EditPopup_text__f8pES"};